module.exports = __webpack_public_path__ + "img/1539260737.b1aa785d.jpg";